module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Bold.2159cae9.woff2";